// Turkish formatting utilities

export const CURRENCY_SYMBOL = { TRY: "TL", USD: "USD", EUR: "EUR" };
export const CURRENCY_OPTIONS = [
  { value: "TRY", label: "TL (Türk Lirası)" },
  { value: "USD", label: "USD (Dolar)" },
  { value: "EUR", label: "EUR (Euro)" },
];

export const fmtMoney = (val, currency = "TRY") => {
  const n = Number(val || 0);
  const sym = CURRENCY_SYMBOL[currency] || currency || "TL";
  const s = n.toLocaleString("tr-TR", {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  }).replace(/\u202F/g, " ");
  return `${s} ${sym}`;
};

export const fmtTL = (val) => fmtMoney(val, "TRY");

export const fmtNum = (val, decimals = 2) => {
  const n = Number(val || 0);
  return n.toLocaleString("tr-TR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const fmtInt = (val) => {
  const n = Number(val || 0);
  return n.toLocaleString("tr-TR", { maximumFractionDigits: 0 });
};

export const fmtDate = (val) => {
  if (!val) return "-";
  try {
    const d = typeof val === "string" ? new Date(val) : val;
    if (Number.isNaN(d.getTime())) return "-";
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}.${mm}.${yyyy}`;
  } catch {
    return "-";
  }
};

export const fmtDateTime = (val) => {
  if (!val) return "-";
  try {
    const d = typeof val === "string" ? new Date(val) : val;
    if (Number.isNaN(d.getTime())) return "-";
    return (
      fmtDate(d) +
      " " +
      String(d.getHours()).padStart(2, "0") +
      ":" +
      String(d.getMinutes()).padStart(2, "0")
    );
  } catch {
    return "-";
  }
};

export const dateInput = (val) => {
  if (!val) return "";
  try {
    const d = typeof val === "string" ? new Date(val) : val;
    if (Number.isNaN(d.getTime())) return "";
    return d.toISOString().slice(0, 10);
  } catch {
    return "";
  }
};

export const todayIso = () => new Date().toISOString().slice(0, 10);
